import { render, staticRenderFns } from "./MnemonicModal.vue?vue&type=template&id=44da5c67&scoped=true&"
import script from "./MnemonicModal.vue?vue&type=script&lang=js&"
export * from "./MnemonicModal.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicModal.vue?vue&type=style&index=0&id=44da5c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da5c67",
  null
  
)

export default component.exports